module.exports = __webpack_public_path__ + "static/media/58.2d4de513.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/58.svg
// module id = 182
// module chunks = 0